import { useLocation } from "react-router-dom";

import { useGameState } from "../game/GameContext";
import { usePwaUpdate } from "../hooks/usePwaUpdate";

export function PwaStatus(): React.JSX.Element | null {
  const pwa = usePwaUpdate();
  const { ui } = useGameState();
  const location = useLocation();
  const safeToUpdate =
    ui.phase === "idle" ||
    ui.phase === "ended" ||
    ui.paused ||
    !location.pathname.endsWith("/play");
  if (!pwa.offlineReady && !pwa.updateAvailable) return null;
  return (
    <aside className="pwa-toast" role="status">
      <span className="pwa-toast__icon">{pwa.updateAvailable ? "↻" : "✓"}</span>
      <div>
        <strong>
          {pwa.updateAvailable
            ? "A clearer forecast is ready"
            : "Offline defense ready"}
        </strong>
        <p>
          {pwa.updateAvailable
            ? safeToUpdate
              ? "Apply the update now."
              : "It will wait for a safe pause."
            : "This device can launch STORMGLASS without a connection."}
        </p>
      </div>
      {pwa.updateAvailable && safeToUpdate && (
        <button
          className="button button--small"
          type="button"
          onClick={pwa.accept}
        >
          Update
        </button>
      )}
      <button
        className="icon-button"
        type="button"
        aria-label="Dismiss"
        onClick={pwa.dismiss}
      >
        ×
      </button>
    </aside>
  );
}
